module.exports = Promise;


//////////////////
// WEBPACK FOOTER
// external "Promise"
// module id = 8
// module chunks = 1